<div class="container-fluid tp-box og-host" [@flipState]="flip">
	<div class="row tp-box__side tp-box__back" *ngIf="flip == 'active'">
		<div class="cw-wrap og-wrap" [ngStyle]="themeVars">
			<div class="cw-icon-badge pointer" (click)="toggleFlip(false, '')" title="Back">
				<i class="material-icons">inventory</i>
			</div>
			<div class="cw-header">
				<div class="cw-title-group">
					<span class="cw-title">{{ title }}</span>
				</div>
				<div class="og-toolbar">
					<button class="btn btn-primary btn-sm" (click)="openWorkList()" title="Review, filter and close outstanding GRNs">Work list</button>
					<button class="btn btn-success btn-sm" (click)="exportXls()"><i class="fa fa-file-excel-o"></i></button>
					<button class="btn btn-danger btn-sm" (click)="exportPdf()"><i class="fa fa-file-pdf-o"></i></button>
				</div>
			</div>
			<div class="cw-body" *ngIf="viewing">
				<div class="table-responsive og-table-wrap" #print_table>
					<table class="table table-sm table-fixed table-hover w-100">
						<thead>
						<tr>
							<th>Vendor#</th>
							<th>GRN#</th>
							<th>Order#</th>
							<th>PO Item</th>
							<th>Date</th>
							<th>Item</th>
							<th>Desc</th>
							<th class="text-right">Price</th>
							<th class="text-center">Ordered</th>
							<th class="text-center">Received</th>
							<th class="text-center">Invoiced</th>
							<th class="text-right">Line Total</th>
						</tr>
						</thead>
						<tbody>
						<tr *ngFor="let d of data">
							<td>{{ d.supplierid }}</td>
							<td>{{ d.grnno}}</td>
							<td>{{ d.orderno}}</td>
							<td>{{ d.podetailitem}}</td>
							<td>{{ d.deliverydate }}</td>
							<td>{{ d.itemcode }}</td>
							<td>{{ d.itemdescription }}</td>
							<td class="text-right">{{ d.unitprice | currency}}</td>
							<td class="text-center">{{ d.quantityord}}</td>
							<td class="text-center">{{ d.qtyrecd}}</td>
							<td class="text-center">{{ d.quantityinv}}</td>
							<td class="text-right">{{ d.unitprice * d.quantityord | currency}}</td>
						</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div class="row tp-box__side tp-box__front" id="frontside" [ngClass]="flip == 'inactive' ? '' : 'd-none'">
		<div class="col-12 p-0">
			<app-dashboard-stat-card
				[title]="title"
				icon="inventory"
				accent="primary"
				[value]="data ? data.length : null"
				[loading]="!data"
				[showView]="!!data?.length"
				(view)="toggleFlip(data, title)">
			</app-dashboard-stat-card>
		</div>
	</div>
</div>
